module.exports = __webpack_public_path__ + "img/weather_bg.0dd37f2b.png";